import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'


interface IFootPrintPortalManager_receiving_orders_gridComponentEntity {
Id?: number, CreatedSysDateTime?: string, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, VendorReference?: string, Status?: { Id?: number, Name?: string }, OrderClass?: { LookupCode?: string, OrderClassTypeId?: number }, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } }, Account?: { Id?: number }, PreferredWarehouse?: { Id?: number, Name?: string }, PreferredCarrier?: { Id?: number, Name?: string }, PreferredCarrierService?: { CarrierId?: number }, ShipmentOrderLookups?: { OrderId?: number, ShipmentId?: number, Shipment?: { LookupCode?: string } }[], Addresses?: { AttentionOf?: string, City?: string, Country?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, PostalCode?: string, PrimaryEmail?: string, PrimaryTelephone?: string, State?: string }[], total_received?: { TotalCount?: number, ExpectedCount?: number, OrderId?: number }, orderline_count?: { ExpectedCount?: number, OrderId?: number }, calculated_total_items?: string}

interface IFootPrintPortalManager_receiving_orders_gridComponentInParams {
  ownerId: number, projectId?: number, warehouseId?: number[], statusIds?: number[], materialIds?: number[], reference?: string, fromDate?: string, toDate?: string}


class FootPrintPortalManager_receiving_orders_gridComponentRowModel extends GridRowModel {
  grid: FootPrintPortalManager_receiving_orders_gridComponent;
  entity: IFootPrintPortalManager_receiving_orders_gridComponentEntity;

  vars: { hasCompletedReceivingTasks?: boolean, hasRemainingReceivingTasks?: boolean, dockAppointmentId?: number } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    lookupcode: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null )
,
null
      ),
    vendor_reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    status: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    orderclass: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    project: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    total_items: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    created_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null , 'datetime', 'l, LT')
,
null
      ),
    expected_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null , 'datetime', 'l, LT')
,
null
      ),
    warehouse: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    carrier: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    ship_from: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    notes: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
  }



  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
) {
    super();
    
  }

  async $initializeExisting(grid: FootPrintPortalManager_receiving_orders_gridComponent, entity: IFootPrintPortalManager_receiving_orders_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: FootPrintPortalManager_receiving_orders_gridComponent, entity?: IFootPrintPortalManager_receiving_orders_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.inParams.fromDate ,
      toDate:  $grid.inParams.toDate ,
      take:  null ,
      skip:  null ,
      dateType:  'CreatedSysDateTime' ,
      reference:  $grid.inParams.reference ,
      materialIds:  $grid.inParams.materialIds ,
    };
    const data = await this.datasources.FootPrintPortalManager.ds_receiving_orders_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.vendor_reference.displayControl as TextModel).text = $row.entity.VendorReference;
    (this.cells.reference.displayControl as TextModel).text = $row.entity.OwnerReference;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.orderclass.displayControl as TextModel).text = $row.entity.OrderClass?.LookupCode;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.PreferredWarehouse?.Name;
    (this.cells.carrier.displayControl as TextModel).text = $row.entity.PreferredCarrier?.Name;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_lookupcode_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootPrintPortalManager_receiving_orders_gridComponentRowModel,
  $grid: FootPrintPortalManager_receiving_orders_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  // Check order class type
   const order = (await $datasources.PurchaseOrders.ds_get_order_by_orderId.get({ orderId: $row.entity.Id })).result;
   if ($utils.isDefined(order)) {
       const orderClassTypeId = order.OrderClass.OrderClassTypeId;
       if (orderClassTypeId == 1) {
           $shell.FootPrintPortalManager.openreceiving_order_editor({ orderId: $row.entity.Id });
       }
        else if(orderClassTypeId == 12) {
          $shell.FootPrintPortalManager.openasn_order_editor({ orderId: $row.entity.Id });
      }
       else {
           throw new Error('Editor for selected order class type under development!')
       }
  
   }
  
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootPrintPortalManager_receiving_orders_gridComponentRowModel,
  $grid: FootPrintPortalManager_receiving_orders_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Apply date format
  if ($utils.isDefined($row.entity.RequestedDeliveryDate)) {
      var expectedDate = $row.entity.RequestedDeliveryDate;
      $row.cells.expected_date.displayControl.text = expectedDate;
  }
  
  if ($utils.isDefined($row.entity.CreatedSysDateTime)) {
      var createdDate = $row.entity.CreatedSysDateTime;
      $row.cells.created_date.displayControl.text = createdDate;
  }
  
  // Apply custom project string logic
  if ($row.entity.Project?.LookupCode === $row.entity.Project?.Name) {
      $row.cells.project.displayControl.text = $row.entity.Project.LookupCode
  } else {
      $row.cells.project.displayControl.text = $row.entity.Project.LookupCode + ' ' + $row.entity.Project.Name
  }
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootPrintPortalManager-receiving_orders_grid',
  templateUrl: './FootPrintPortalManager.receiving_orders_grid.component.html'
})
export class FootPrintPortalManager_receiving_orders_gridComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootPrintPortalManager_receiving_orders_gridComponentEntity[];

  pageSize = 100;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootPrintPortalManager_receiving_orders_gridComponentInParams = { ownerId: null, projectId: null, warehouseId: [], statusIds: [], materialIds: [], reference: null, fromDate: null, toDate: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'Lookup', false, false, null),       vendor_reference: new GridHeaderModel(new HeaderStyles(null, null), 'Vendor reference', false, false, null),       reference: new GridHeaderModel(new HeaderStyles(null, null), 'Owner reference', false, false, null),       status: new GridHeaderModel(new HeaderStyles(null, null), 'Status', false, false, null),       orderclass: new GridHeaderModel(new HeaderStyles(null, null), 'Order class', false, false, null),       project: new GridHeaderModel(new HeaderStyles(null, null), 'Project', false, false, null),       total_items: new GridHeaderModel(new HeaderStyles(null, null), 'Total items', false, false, null),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'Created', false, false, null),       expected_date: new GridHeaderModel(new HeaderStyles(null, null), 'Expected', false, false, null),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse', false, false, null),       carrier: new GridHeaderModel(new HeaderStyles(null, null), 'Carrier', false, false, null),       ship_from: new GridHeaderModel(new HeaderStyles(null, null), 'Ship from', false, false, null),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootPrintPortalManager_receiving_orders_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('reference') set $inParams_reference(value: any) {
    this.inParams['reference'] = value;
  }
  get $inParams_reference(): any {
    return this.inParams['reference'] ;
  }
  @Input('fromDate') set $inParams_fromDate(value: any) {
    this.inParams['fromDate'] = value;
  }
  get $inParams_fromDate(): any {
    return this.inParams['fromDate'] ;
  }
  @Input('toDate') set $inParams_toDate(value: any) {
    this.inParams['toDate'] = value;
  }
  get $inParams_toDate(): any {
    return this.inParams['toDate'] ;
  }

  topToolbar = {
      update: new ToolModel(new ButtonModel('update', new ButtonStyles(null, null), false, 'Update', 'ms-Icon ms-Icon--Edit')
    ),
      refresh: new ToolModel(new ButtonModel('refresh', new ButtonStyles(null, null), false, 'Refresh', 'ms-Icon ms-Icon--Process')
    ),
      separator2: new ToolModel(new SeparatorModel(new Styles(null, null))
    ),
      cancel: new ToolModel(new ButtonModel('cancel', new ButtonStyles(null, null), false, 'Cancel', 'icon-ic_fluent_dismiss_circle_20_regular')
    ),
      on_delete: new ToolModel(new ButtonModel('on_delete', new ButtonStyles(['destructive'], null), false, 'Delete', 'ms-Icon ms-Icon--Delete')
    ),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    ),
      attachments: new ToolModel(new ButtonModel('attachments', new ButtonStyles(null, null), false, ' ', 'ms-Icon ms-Icon--Attach')
    )
  };

  bottomToolbar = {
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: FootPrintPortalManager_ShellService,
    private datasources: FootPrintPortalManager_DatasourceService,
    private flows: FootPrintPortalManager_FlowService,
    private reports: FootPrintPortalManager_ReportService,
    private localization: FootPrintPortalManager_LocalizationService,
    private operations: FootPrintPortalManager_OperationService,
    ) {
    this.title = 'Receiving orders';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if(!this.$hasMissingRequiredInParams) {
      this.$init();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.ownerId)) {
        this.$missingRequiredInParams.push('ownerId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      fromDate:  $grid.inParams.fromDate ,
      toDate:  $grid.inParams.toDate ,
      take:  null ,
      skip:  null ,
      dateType:  'CreatedSysDateTime' ,
      reference:  $grid.inParams.reference ,
      materialIds:  $grid.inParams.materialIds ,
    };
    try {
    const data = await this.datasources.FootPrintPortalManager.ds_receiving_orders_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootPrintPortalManager_receiving_orders_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  selectedRows = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const selectedRowsCount = $grid.selectedRows.length;
  
  // One or more rows selected
  if (selectedRowsCount > 0) {
      if (selectedRowsCount === 1) {
          // Attachments
          $grid.topToolbar.attachments.control.readOnly = !(await checkAttachments());
      }
  
  
      $grid.topToolbar.cancel.control.readOnly = true;
      $grid.topToolbar.on_delete.control.readOnly = true;
      $grid.topToolbar.update.control.readOnly = true;
      $grid.topToolbar.attachments.control.readOnly = true;
  
      // Cancellation
      $grid.topToolbar.cancel.control.readOnly = !(await checkAllCancellable());
  
      // Deletion
      $grid.topToolbar.on_delete.control.readOnly = !(await checkAllDeletable());
  
      // Update
      $grid.topToolbar.update.control.readOnly = !(await checkAllUpdatable());
  
  
  
  }
  else {
  
      $grid.topToolbar.cancel.control.readOnly = true;
      $grid.topToolbar.on_delete.control.readOnly = true;
      $grid.topToolbar.update.control.readOnly = true;
      $grid.topToolbar.attachments.control.readOnly = true;
  }
  
  
  /**************************************************** 
   * FUNCTIONS
  *****************************************************/
  
  
  async function checkAllDeletable() {
      let allow = $grid.selectedRows.length > 0;
  
      for (let row of $grid.selectedRows) {
          if ($utils.isAllDefined(row.entity.Id, row.entity.OrderStatusId)) {
              // Purchase Order
              if (row.entity.OrderClass.OrderClassTypeId === 1) {
                  if ($utils.isDefined((await $flows.PurchaseOrders.is_purchase_order_deletable_flow({ orderId: row.entity.Id })).reasons)) {
                      return false;
                  }
                  if (await $operations.FootPrintPortalManager.Disable_ReceivingOrder_Delete.isAuthorized()) {
                      return false;
                  }
              }
              // ASN Order
              else if (row.entity.OrderClass.OrderClassTypeId === 12) {
                  let results = (await $flows.AsnOrders.is_asn_order_deletable_flow({
                      orderId: row.entity.Id,
                      optimalInputs: {
                          statusId: row.entity.OrderStatusId,
                          hasCompletedReceivingTasks: row.vars.hasCompletedReceivingTasks
                      }
                  }));
  
                  if ($utils.isDefined(results.reasons)) {
                      return false;
                  }
  
                  if (await $operations.FootPrintPortalManager.Disable_AsnOrder_Delete.isAuthorized()) {
                      return false;
                  }
              }
          }
          else {
              return false;
          }
      }
  
      return allow;
  }
  
  async function checkAllCancellable() {
      let allow = $grid.selectedRows.length > 0;
  
      for (let row of $grid.selectedRows) {
          if ($utils.isDefined(row.entity.ShipmentOrderLookups)) {
              // Purchase Order
              if (row.entity.OrderClass.OrderClassTypeId === 1) {
                  if ($utils.isDefined((await $flows.PurchaseOrders.is_purchase_order_cancelable_flow({
                      orderId: row.entity.Id,
                      shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
                  })).reasons)) {
                      return false;
                  }
  
                  if (await $operations.FootPrintPortalManager.Disable_ReceivingOrder_Cancel.isAuthorized()) {
                      return false;
                  }
                  // Wait status
                  if (row.entity.OrderStatusId === 128){
                      return false;
                  }
              }
              // ASN Order
              else if (row.entity.OrderClass.OrderClassTypeId === 12) {
                  if ($utils.isDefined((await $flows.AsnOrders.is_asn_order_cancelable_flow({
                      orderId: row.entity.Id,
                      optimalInputs: {
                          statusId: row.entity.OrderStatusId,
                          hasCompletedReceivingTasks: row.vars.hasCompletedReceivingTasks
                      }
                  })).reasons)) {
                      return false;
                  }
                  if (await $operations.FootPrintPortalManager.Disable_AsnOrder_Cancel.isAuthorized()) {
                      return false;
                  }
              }
          }
          else {
              return false;
          }
      }
  
      return allow;
  }
  
  async function checkAttachments() {
      let allow = $grid.selectedRows.length > 0;
  
      for (let row of $grid.selectedRows) {
          if ($utils.isDefined(row.entity.ShipmentOrderLookups)) {
              // Purchase Order
              if (row.entity.OrderClass.OrderClassTypeId === 1) {
  
                  if (await $operations.FootPrintPortalManager.Disable_ReceivingOrder_Attachments.isAuthorized()) {
                      return false;
                  }
  
              }
              // ASN Order
              else if (row.entity.OrderClass.OrderClassTypeId === 12) {
  
                  if (await $operations.FootPrintPortalManager.Disable_AsnOrder_Attachments.isAuthorized()) {
                      return false;
                  }
              }
          }
          else {
              return false;
          }
      }
  
      return allow;
  }
  
  
  async function checkAllUpdatable() {
      let allow = $grid.selectedRows.length > 0;
  
      for (let row of $grid.selectedRows) {
          if ($utils.isDefined(row.entity.ShipmentOrderLookups)) {
              // Purchase Order
              if (row.entity.OrderClass.OrderClassTypeId === 1) {
  
                  if (await $operations.FootPrintPortalManager.Disable_ReceivingOrder_Update.isAuthorized()) {
                      return false;
                  }
  
              }
              // ASN Order
              else if (row.entity.OrderClass.OrderClassTypeId === 12) {
  
                  if (await $operations.FootPrintPortalManager.Disable_AsnOrder_Update.isAuthorized()) {
                      return false;
                  }
              }
          }
          else {
              return false;
          }
      }
  
      return allow;
  }
  
  
  
  }
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootPrintPortalManager.openErrorDialog('Error cancelling orders', 'No orders selected.');
      return;
  } else {
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
  
          if (row.entity.OrderClass.OrderClassTypeId === 1) {
              const flowParams = {
                  orderId: row.entity.Id,
                  shipmentId: row.entity.ShipmentOrderLookups[0].ShipmentId
              };
              var confirmResult = await $flows.PurchaseOrders.is_purchase_order_cancelable_flow(flowParams);
          }
          const reasons = confirmResult?.reasons;
          if ($utils.isDefined(reasons)) {
              failures.push(row);
              errors.push(`Order ${row.entity.LookupCode} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: reasons})).formattedValue}`);
          } else {
              candidates.push(row);
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Error cancelling orders';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.LookupCode).join(', ')} cannot be cancelled`;
          const errorList = errors;
          await $shell.FootPrintPortalManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.LookupCode).join(', ')} - Once cancelled, the order cannot be restored.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some order(s) cannot be cancelled';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootPrintPortalManager.openConfirmationDialog(title, message);
          } else {
              const title = 'Cancel the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootPrintPortalManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const CandidateSuccess = [];
              const CandidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      let reasons: string[];
                      if (candidate.entity.OrderClass.OrderClassTypeId === 1) {
                          const flowParams = {
                              orderId: candidate.entity.Id
                          }
                          let result = await $flows.PurchaseOrders.cancel_purchase_order_flow(flowParams);
                          if ($utils.isDefined(result.reasons)) {
                              reasons = result.reasons;
                          }
                      }
                      else if (candidate.entity.OrderClass.OrderClassTypeId === 12) {
                          let result = await $flows.AsnOrders.cancel_asn_order_flow({orderId: candidate.entity.Id});
                          reasons = result.reasons
                      }
                      
                      if ($utils.isDefined(reasons)) {
                          CandidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.LookupCode} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: reasons})).formattedValue}`);
                      } else {
                          CandidateSuccess.push(candidate);
                      }
  
  
                  } catch (error) {
                      CandidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (CandidateSuccess.length === candidates.length) {
                  const title = 'All order(s) cancelled';
                  const message = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} cancelled`;
                  await $shell.FootPrintPortalManager.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (CandidateFailures.length === candidates.length) {
                      const title = 'All order(s) failed to cancel';
                      const message = `Order(s) ${CandidateFailures.map(c => c.entity.LookupCode).join(',')} could not be cancelled`;
                      await $shell.FootPrintPortalManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some order(s) could not be cancelled';
                      const success = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} were cancelled.`;
                      const errors = `The following order(s) could not be cancelled: ${CandidateFailures.map(c => c.entity.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootPrintPortalManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootPrintPortalManager.openErrorDialog('Error deleting orders', 'No orders selected.');
      return;
  } else {
      const candidates = [];
      const failures = [];
      const errors = [];
      for (const row of selectedRows) {
          if (row.entity.OrderClass.OrderClassTypeId === 1) {
              const flowParams = {
                  orderId: row.entity.Id
              };
              var confirmResult = await $flows.PurchaseOrders.is_purchase_order_deletable_flow(flowParams);
          }
          const reasons = confirmResult?.reasons;
          if ($utils.isDefined(reasons)) {
              failures.push(row);
              errors.push(`Order ${row.entity.LookupCode} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: reasons})).formattedValue}`);
          } else {
              candidates.push(row);
          }
      }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Error deleting orders';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.LookupCode).join(', ')} cannot be deleted`;
          const errorList = errors;
          await $shell.FootPrintPortalManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.LookupCode).join(', ')} - Once deleted, the order cannot be restored.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some order(s) cannot be deleted';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootPrintPortalManager.openConfirmationDialog(title, message);
          } else {
              const title = 'Delete the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootPrintPortalManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const CandidateSuccess = [];
              const CandidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      let reasons: string[];
                      if (candidate.entity.OrderClass.OrderClassTypeId === 1) {
                          const flowParams = {
                              orderId: candidate.entity.Id
                          }
                          let reason = (await $flows.PurchaseOrders.delete_purchase_order_flow(flowParams)).reason;
                          if ($utils.isDefined(reason)) {
                              reasons = [reason];
                          }
                      }
                      else if (candidate.entity.OrderClass.OrderClassTypeId === 12) {
                          reasons = (await $flows.AsnOrders.delete_asn_order_flow({ orderId: candidate.entity.Id })).reasons;
                      }
                      
                      if ($utils.isDefined(reasons)) {
                          CandidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.LookupCode} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: reasons})).formattedValue}`);
                      } else {
                          CandidateSuccess.push(candidate);
                      }
  
                  } catch (error) {
                      CandidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (CandidateSuccess.length === candidates.length) {
                  const title = 'All order(s) deleted';
                  const message = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} deleted`;
                  await $shell.FootPrintPortalManager.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (CandidateFailures.length === candidates.length) {
                      const title = 'All order(s) failed to delete';
                      const message = `Order(s) ${CandidateFailures.map(c => c.entity.LookupCode).join(',')} could not be deleted`;
                      await $shell.FootPrintPortalManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some order(s) could not be deleted';
                      const success = `Order(s) ${CandidateSuccess.map(c => c.entity.LookupCode).join(',')} were deleted.`;
                      const errors = `The following order(s) could not be deleted: ${CandidateFailures.map(c => c.entity.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootPrintPortalManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_update_clicked(event = null) {
    return this.on_update_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_update_clickedInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootPrintPortalManager.openErrorDialog('Order Update Error', 'No orders selected.');
      return;
  } else {
  
      const dialogResult = await $shell.FootPrintPortalManager.openreceiving_orders_update_formDialog();
      const userConfirmed = dialogResult.confirm;
      const carrierId = dialogResult.carrierId;
      const reference = dialogResult.reference;
      const expectedDate = dialogResult.expectedDate;
  
      let payload: any = {};
      let shipmentpayload: any = {};
  
      if (userConfirmed) {
          for (const row of selectedRows) {
  
              if ($utils.isDefined(carrierId)) {
                  payload.PreferredCarrierId = carrierId;
                  shipmentpayload.CarrierId = carrierId;
              }
              if (expectedDate) {
                  payload.RequestedDeliveryDate = expectedDate;
              }
               if (reference) {
                  payload.OwnerReference = reference;
              }
  
  
              await $flows.Utilities.crud_update_flow({ entitySet: 'Orders', id: row.entity.Id, entity: payload });
              await $flows.Utilities.crud_update_flow({ entitySet: 'Shipments', id: row.entity.ShipmentOrderLookups[0].ShipmentId, entity: shipmentpayload });
          }
          await $grid.refresh();
      }
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const exportLimit = $settings.FootPrintPortalManager.ExcelExportLimit
  
  let exportAsDetails = await $shell.FootPrintPortalManager.openConfirmationDialog('Choose Export', 'Export Details or Summary?', 'Details', 'Summary');
  if (!$utils.isDefined(exportAsDetails)) { return; }
  
  //Initialize
  var wb = $event;
  var transactions = [];
  var totalRecords: number;
  var exportType: string = "Summary";
  
  let dateFormat = $settings.FootPrintPortalManager.DateFormat ?? "MM/dd/yyyy";
  
  // Get Selected Rows only. 
  if ($grid.selectedRows.length > 0) {
      var orderIds = [...new Set($grid.selectedRows.map(o => o.entity.Id))]
      totalRecords = $grid.selectedRows.length;
  } else {
      if (!exportAsDetails) {
          totalRecords = (await $datasources.PurchaseOrders.ds_inbound_orders_grid_count.get({
              ownerId: $grid.inParams.ownerId,
              projectId: $grid.inParams.projectId,
              warehouseId: $grid.inParams.warehouseId,
              statusIds: $grid.inParams.statusIds,
              fromDate: $grid.inParams.fromDate,
              toDate: $grid.inParams.toDate,
              dateType: 'CreatedSysDateTime',
              fullTextSearch: $grid.fullTextSearch,
              reference: $grid.inParams.reference
          })).totalCount;
      } else {
          exportType = "Details"
          totalRecords = (await $datasources.PurchaseOrders.ds_inbound_orders_details_grid_count.get({
              ownerId: $grid.inParams.ownerId,
              projectId: $grid.inParams.projectId,
              warehouseId: $grid.inParams.warehouseId,
              statusIds: $grid.inParams.statusIds,
              fromDate: $grid.inParams.fromDate,
              toDate: $grid.inParams.toDate,
              dateType: 'CreatedSysDateTime',
              fullTextSearch: $grid.fullTextSearch,
              reference: $grid.inParams.reference
          })).totalCount;
      }
  }
  if (totalRecords > exportLimit) {
      (await $shell.Inventory.openInfoDialog(`Export limitation of ${exportLimit} exceeded`, `Excel will only export the first ${exportLimit} records`));
  }
  transactions = (await $flows.PurchaseOrders.excel_export_flow({
      ownerId: $grid.inParams.ownerId,
      projectId: $grid.inParams.projectId,
      warehouseIds: $grid.inParams.warehouseId,
      statusIds: $grid.inParams.statusIds,
      fromDate: $grid.inParams.fromDate,
      toDate: $grid.inParams.toDate,
      dateType: 'CreatedSysDateTime',
      fullTextSearch: $grid.fullTextSearch,
      orderIds: orderIds,
      exportLimit: exportLimit,
      reference: $grid.inParams.reference,
      exportType: exportType,
      totalRecords: totalRecords,
      dateFormat: dateFormat
  })).transactions;
  
  
  var ws = $utils.excel.json_to_sheet(transactions);
  
  $utils.excel.book_append_sheet(wb, ws, "InboundOrdersExport");
  
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/14/2023
  
  const inbound_orders = $grid.rows.map(row => row.entity.Id);
  
  const purchase_orders = $grid.rows.filter(o => o.entity.OrderClass.OrderClassTypeId !== 12).map(o => { return { "orderId": o.entity.Id, "additionalData": [{ "lookupCode": o.entity.LookupCode }] } });
  const asn_orders = $grid.rows.filter(o => o.entity.OrderClass.OrderClassTypeId === 12).map(o => { return { "orderId": o.entity.Id, "additionalData": [{ "lookupCode": o.entity.LookupCode }] } });
  
  let order_lookupCodes: { orderId?: number, formattedLookupCode?: string }[];
  
  if (inbound_orders.length > 0) {
  
      const order_tasks = (await $datasources.PurchaseOrders.ds_get_orders_aggregated_tasks.get({ orderIds: inbound_orders, operationCodeIds: [2] })).result;
      const order_properties = (await $datasources.PurchaseOrders.ds_inbound_orders_grid_properties.get({ orderIds: inbound_orders })).result;
      const expected_inbound = (await $datasources.PurchaseOrders.ds_get_orders_aggregated_expected.get({ orderIds: inbound_orders })).result;
      const order_addresses = (await $flows.Addresses.get_addresses_single_string_by_orderIds({ orderIds: inbound_orders }));
  
      // Get formatted lookupcode
      if ($utils.isDefined(purchase_orders)) { // PurchaseOrder
          if (purchase_orders.length > 0) {
              let formatted_lookup = (await $flows.PurchaseOrders.format_order_lookupcode_flow_multiple({
                  orders: purchase_orders,
                  context: 'inbound_orders_grid'
              }));
              if ($utils.isDefined(formatted_lookup)) {
                  if ($utils.isDefined(formatted_lookup.orders)) {
                      if (formatted_lookup.orders.length > 0) {
                          order_lookupCodes = formatted_lookup.orders;
                      };
                  };
              };
          };
      };
  
      if ($utils.isDefined(asn_orders)) { // Inbound ASN
          if (asn_orders.length > 0) {
              let formatted_lookup = (await $flows.AsnOrders.format_order_lookupcode_flow_multiple({
                  orders: asn_orders,
                  context: 'inbound_orders_grid'
              }));
              if ($utils.isDefined(formatted_lookup)) {
                  if ($utils.isDefined(formatted_lookup.orders)) {
                      if (formatted_lookup.orders.length > 0) {
                          if ($utils.isDefined(order_lookupCodes)) {
                              order_lookupCodes = order_lookupCodes.concat(formatted_lookup.orders);
                          } else {
                              order_lookupCodes = formatted_lookup.orders;
                          };
                      };
                  };
              };
          };
      };
  
      const receiving_tasks = order_tasks.filter(t => (t.StatusId === 2 && t.ActualAmount > 0))
      const pending_tasks = order_tasks.filter(t => ((t.StatusId === 4 || t.StatusId === 1) && t.ExpectedAmount > 0))
  
      const properties_array = order_properties.map(row => row.Id);
      const receiving_array = receiving_tasks.map(row => row.OrderId);
      const pending_array = pending_tasks.map(row => row.OrderId);
      const expected_array = expected_inbound.map(row => row.OrderId);
      const address_array = order_addresses.Addresses.map(row => row.OrderId);
      const lookup_array = order_lookupCodes?.map(row => row.orderId);
  
      for (let row of $grid.rows) {
  
          let received_total = 0;
          let expected_total = 0;
          let orderIndex = -1;
  
          let orderId = row.entity.Id;
          let order_status_id = row.entity.OrderStatusId;
  
          //Get the lookupCode
          if ($utils.isDefined(lookup_array)) {
              orderIndex = lookup_array.indexOf(orderId)
              if (orderIndex >= 0) {
                  row.cells.lookupcode.displayControl.text = order_lookupCodes[orderIndex].formattedLookupCode;
              };
          };
  
          //Get the total received inventory
          orderIndex = receiving_array.indexOf(orderId)
          if (orderIndex >= 0) {
              received_total = receiving_tasks[orderIndex].ActualAmount;
          };
  
          //Get the total expected inventory
          orderIndex = expected_array.indexOf(orderId)
          if (orderIndex >= 0) {
              expected_total = expected_inbound[orderIndex].Amount;
          };
  
          //Created
          if (row.entity.Status.Id === 1 && expected_total > 0) {
              row.cells.total_items.displayControl.text = `${expected_total}`
          };
  
          //Canceled
          if (row.entity.Status.Id === 8 && received_total > 0) {
              row.cells.total_items.displayControl.text = `${received_total}`
          };
  
          //Processing or Completed
          if ((row.entity.Status.Id === 2 || row.entity.Status.Id === 4) && received_total >= 0 && expected_total > 0) {
              row.cells.total_items.displayControl.text = `${received_total} of ${expected_total}`
          };
  
          // Check tasks
  
          let has_receiving = false;
          let has_pending = false;
  
          orderIndex = receiving_array.indexOf(orderId)
          if (orderIndex >= 0) {
              has_receiving = true;
          };
  
          orderIndex = pending_array.indexOf(orderId)
          if (orderIndex >= 0) {
              has_pending = true;
          };
  
          row.vars.hasCompletedReceivingTasks = has_receiving;
          row.vars.hasRemainingReceivingTasks = has_pending;
  
          if (order_status_id === 2) {
  
              let order_state = 0;
  
              // All receiving tasks in a planned status
              if (has_pending && !has_receiving) {
                  order_state = 2;
              }
              // One or more receiving tasks completed and one or more receiving tasks released
              else if (has_pending && has_receiving) {
                  order_state = 3;
              }
  
              // No more released receiving tasks where the expected packaged amount gt 0 and at least one completed receiving task
              else if (!has_pending && has_receiving) {
                  order_state = 4;
              };
  
              if ($utils.isDefined(order_state)) {
                  switch (order_state) {
                      case 2: {
                          row.cells.status.displayControl.text = 'Ready to receive'
                          break;
                      }
                      case 3: {
                          row.cells.status.displayControl.text = 'Receiving in progress'
                          break;
                      }
                      case 4: {
                          row.cells.status.displayControl.text = 'Ready to complete'
                          break;
                      };
                  };
              };
          };
  
          if (order_status_id === 128){
               row.cells.status.displayControl.text = 'Wait'
          }
  
       
  
          //Set the Ship_From
          orderIndex = address_array.indexOf(orderId)
          if (orderIndex >= 0) {
  
              let address = order_addresses.Addresses[orderIndex]
  
              if ($utils.isDefined(address)) {
  
                  let ship_from = address.Address;
  
                  if (!ship_from.includes('ord-')) {
                      row.cells.ship_from.displayControl.text = ship_from
                  }
                  else {
                      row.cells.ship_from.displayControl.text = '';
                  };
              };
          };
      };
  
    
  };
  }
  on_attachments_clicked(event = null) {
    return this.on_attachments_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_attachments_clickedInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length === 1) {
  
      await $shell.FootPrintPortalManager.openentity_attachments_gridDialog({
          entityType: 'Order', entityKeys: [{ name: 'Id', value: $grid.selectedRows[0].entity.Id }]
      });
  
  }
  }
  on_refresh(event = null) {
    return this.on_refreshInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refreshInternal(
    $grid: FootPrintPortalManager_receiving_orders_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  $grid.refresh();
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'FootPrintPortalManager_receiving_orders_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
